const STORAGE_KEY = 'klienci_list_filters'
const LEGACY_PLACOWKI_KEY = 'placowki_list_filters'

export const GEO_FILTER_KEYS = [
	'id_miasto',
	'id_gmina',
	'id_powiat',
	'id_wojewodztwo',
	'id_typ',
]

const PAGE_KEYS = ['placowki', 'miasto', 'gmina', 'powiat', 'wojewodztwa', 'typyPlacowek']

const createDefaultState = () => ({
	geo: {
		id_miasto: null,
		id_gmina: null,
		id_powiat: null,
		id_wojewodztwo: null,
		id_typ: null,
	},
	search: Object.fromEntries(PAGE_KEYS.map(key => [key, ''])),
	placowki: { triage: null },
})

const normalizeStoredId = value =>
	value === null || value === undefined || value === '' ? null : value

const normalizeStoredTriage = value =>
	value !== null && value !== undefined && value !== '' ? Number(value) : null

const normalizeGeo = (geo = {}) =>
	GEO_FILTER_KEYS.reduce((acc, key) => {
		acc[key] = normalizeStoredId(geo[key])
		return acc
	}, {})

const migrateLegacyPlacowkiFilters = legacy => {
	const state = createDefaultState()
	state.geo = normalizeGeo(legacy)
	state.search.placowki = typeof legacy.searchText === 'string' ? legacy.searchText : ''
	state.placowki.triage = normalizeStoredTriage(legacy.triage)
	return state
}

const normalizeState = stored => {
	const state = createDefaultState()

	if (stored?.geo) {
		state.geo = normalizeGeo(stored.geo)
	}

	if (stored?.search && typeof stored.search === 'object') {
		for (const key of PAGE_KEYS) {
			if (typeof stored.search[key] === 'string') {
				state.search[key] = stored.search[key]
			}
		}
	}

	if (stored?.placowki) {
		state.placowki.triage = normalizeStoredTriage(stored.placowki.triage)
	}

	return state
}

const loadRawState = () => {
	try {
		const raw = localStorage.getItem(STORAGE_KEY)
		if (!raw) {
			const legacy = localStorage.getItem(LEGACY_PLACOWKI_KEY)
			if (legacy) {
				return migrateLegacyPlacowkiFilters(JSON.parse(legacy))
			}
			return createDefaultState()
		}

		return normalizeState(JSON.parse(raw))
	} catch {
		return createDefaultState()
	}
}

const pickGeo = filters =>
	GEO_FILTER_KEYS.reduce((acc, key) => {
		if (key in filters) {
			acc[key] = filters[key]
		}
		return acc
	}, {})

export function loadFiltersForPage(pageKey) {
	const state = loadRawState()
	const filters = {
		...state.geo,
		searchText: state.search[pageKey] || '',
	}

	if (pageKey === 'placowki') {
		filters.triage = state.placowki.triage
	}

	return filters
}

export function persistFiltersForPage(pageKey, filters) {
	try {
		const state = loadRawState()
		state.geo = normalizeGeo({
			...state.geo,
			...pickGeo(filters),
		})
		state.search[pageKey] = filters.searchText || ''

		if (pageKey === 'placowki') {
			state.placowki.triage = normalizeStoredTriage(filters.triage)
		}

		localStorage.setItem(STORAGE_KEY, JSON.stringify(state))
		localStorage.removeItem(LEGACY_PLACOWKI_KEY)
	} catch {
		// Ignore storage quota or access errors.
	}
}

export function applyGeoFilterAndNavigate(navigate, { targetPageKey, path, filterKey, filterValue }) {
	if (!filterValue) return

	const filters = loadFiltersForPage(targetPageKey)
	persistFiltersForPage(targetPageKey, {
		...filters,
		[filterKey]: filterValue,
	})
	navigate(path)
}
